import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { clearProductReportError, productReportError } from 'b2b-apps/shop/product/redux/productReportError/actionCreators';
import { getProductReportError } from 'b2b-apps/shop/product/redux/productReportError/selectors';

type UseProductReportErrorEffectReturnType = {
  data: ReturnType<typeof getProductReportError>
  reportProductError: typeof productReportError,
  clearReportProductError: typeof clearProductReportError,
};

const useProductReportErrorEffect = (): UseProductReportErrorEffectReturnType => {
  const dispatch = useDispatch();
  const data = useSelector(getProductReportError);
  const reportProductError = useMemo(
    () => bindActionCreators(productReportError, dispatch),
    [dispatch],
  );

  const clearReportProductError = useMemo(
    () => bindActionCreators(clearProductReportError, dispatch),
    [dispatch],
  );

  return {
    data,
    reportProductError,
    clearReportProductError,
  };
};

export { useProductReportErrorEffect };
export type { UseProductReportErrorEffectReturnType };
